import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { startLoading } from '../../../redux/reducers/loadingSlice';
import { setSelectAddress } from '../../../redux/reducers/createOrderSlice';
import { toSentenceCase } from '../../../utils/commonFuncs';
import axios from "axios";
import { useNavigate } from "react-router-dom";




const CMSVerifier = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const handleFetchSetData = async () => {
        const mapData = await axios.get(`https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${searchParams.get('postalcode')}&returnGeom=Y&getAddrDetails=Y&pageNum=1`)
        if (mapData && mapData?.results?.length) {
            dispatch(setSelectAddress(
                {
                    selectedAddress: {
                        address: toSentenceCase(`${mapData?.results[0]?.BLK_NO !== 'NIL' ? mapData?.results[0]?.BLK_NO : ''}` + ` ${mapData?.results[0]?.ROAD_NAME !== 'NIL' ? mapData?.results[0]?.ROAD_NAME : ''}`),
                        country: 'Singapore',
                        postalCode: mapData?.results[0]?.POSTAL,
                        isPrimary: true,
                        isActive: true,
                        isFromInput: true,
                        unitNo: toSentenceCase(`${mapData?.results[0]?.BUILDING !== 'NIL' ? mapData?.results[0]?.BUILDING : ''}`),
                        location: {
                            type: "Point",
                            coordinates: [Number(Number(mapData?.results[0].LONGITUDE).toFixed(6)), Number(Number(mapData?.results[0].LATITUDE).toFixed(6))]
                        }
                    }
                }
            ))
            navigate(`/${searchParams.get('service')}`)
        }
        else {
            navigate('/dashboard')
        }
    }

    useEffect(() => {
        handleFetchSetData()
    }, [])
    return (
        <div>CMSVerifier</div>
    )
}

export default CMSVerifier